import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import styles from './UserFeedback.module.less';
import { setUserFeedbackVisible } from '../../actions/layout';
import { setFeedbackTab } from '../../actions/userFeedback';
import Submit from '../../pages/UserFeedback/Submit';
import Record from '../../pages/UserFeedback/Record';
import Question from '../../pages/UserFeedback/Question';
import { logging } from '../../actions/log';
import fly from '../../static/logo.svg';

const tabs = [
  {
    name: 'submit',
    text: '我要反馈',
  },
  {
    name: 'record',
    text: '反馈记录',
  },
  {
    name: 'question',
    text: '常见问题',
  },
];

const selectFeedbackTab = createSelector(
  state => state.userFeedback,
  userFeedback => userFeedback.feedbackTab,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default () => {
  const feedbackTab = useSelector(selectFeedbackTab) || 'submit';
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();
  // 页面展现打桩
  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Feedback',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);
  const handleTabs = type => () => {
    dispatch(setFeedbackTab(type));
    // 点击tab打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Feedback_Tab',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: type === 'sumbit' ? 'feedback' : type,
        },
      }),
    );
  };

  const handleClose = () => {
    dispatch(setFeedbackTab('submit'));
    dispatch(setUserFeedbackVisible(false));
  };
  return (
    <>
      <div className={styles.mask}>
        <div className={styles.content_box}>
          <div className={styles.title}>
            <img src={fly} alt="" width="18px" className={styles.logo} />
            <span className={styles.text}>联想软件商店</span>
            <i
              className={classNames('icon iconfont icon-close', styles.close_icon)}
              onClick={handleClose}
            />
          </div>
          <ul className={styles.tabs}>
            {tabs.map(tab => (
              <li
                key={tab.name}
                onClick={handleTabs(tab.name)}
                className={classNames({ [styles.active]: feedbackTab === tab.name })}
              >
                {tab.text}
              </li>
            ))}
          </ul>
          <div className={styles.main_content}>
            {feedbackTab === 'submit' && <Submit />}
            {feedbackTab === 'record' && <Record />}
            {feedbackTab === 'question' && <Question />}
          </div>
        </div>
      </div>
    </>
  );
};
